import React, { Component, useRef } from 'react';
import {
    Alert,
    Tabs,
    DatePicker,
    Select,
    Tooltip,
    Input,
    Button,
    Pagination,
    InputNumber,
    Spin,
    Table,
    message
} from 'antd';
import './list.less'
import '@/static/style/basetable.less'
import moment from 'moment'
import { TablePipeline, features, BaseTable } from 'ali-react-table'
import { Checkbox } from '@alifd/next'
import _, { get, set } from 'lodash';
import { getFormatDate, outputMoney, getSid, objToArr, } from '@/public/utils'
import MatchedList from './waitMatched';
import { getWaitDataApi, setTemp } from './api'
import { fetchSigoCompany, fetchSystemInvoice } from '../common/api'
import { getFormatDateIsNull, sameChange,filterSigoCompanyCol } from '../common/utils'
import { getCookieNew } from '../../../../public/utils';

class Matchlist extends Component {

    constructor(props) {
        super(props);
        this.state = {
            tab: "1",
            waitSearchParams: {
                page_no: 1,
                page_size: 20,
                query: {
                    supplier_account_code: "",
                    buyer_no: null,
                    beign_date: null,
                    end_date: null,
                    is_all: true,
                    sid: '',
                    matchs_staus_list: ['00', '01'],
                    supplier_no:getCookieNew('supplier_code')||''
                }
            },
            dataSource: {
                wait: [],
            },
            selectedRows: [],
            loading: { all: false },
            sigoCompanys: [],
            pipelineState: {}
        };
    }

    getSystemInvoice = async () => {
        try {
            this.setLoading(true)
            let res = await fetchSystemInvoice()
            this.setLoading(false)
            if (_.get(res, "status") === 200) {
                message.success("手动获取成功！")
                window.location.reload()
            }
        } catch (err) {
            this.setLoading(false)
        }
    }

    setLoading = (isloading) => {
        let { loading } = this.state
        set(loading, 'all', isloading)
        this.setState({ loading })
    }

    componentDidMount() {
        this.init()
        this.querySigoCompany()
    }

    init = () => {
        let { waitSearchParams } = this.state
        set(waitSearchParams, 'query.sid', getSid())
        this.setState({
            waitSearchParams,
        }, () => {
            this.getWaitData()
        })
    }

    querySigoCompany = async () => {
        try {
            const {
                data = {}
            } = (await fetchSigoCompany()) || {}
            this.setState({ sigoCompanys: objToArr(get(data, 'data')) })
        } catch (err) {
            console.log(err)
        }
    }

    changeLoading = (load) => {
        let { loading } = this.state
        set(loading, 'wait_table', load)
        this.setState({
            loading
        })
    }

    objToArrObj = (obj) => {
        for (var key in obj) {
            obj[key] = objToArr(obj[key])
        }
        return obj
    }

    getWaitData = async () => {
        try {
            let { waitSearchParams } = this.state
            var params = _.cloneDeep(waitSearchParams)
            set(params, 'query.supplier_account_begin_date', get(params, 'query.beign_date') ? get(params, 'query.beign_date').valueOf() : null)
            set(params, 'query.supplier_account_end_date', get(params, 'query.end_date') ? get(params, 'query.end_date').valueOf() : null)
            delete params.query.beign_date
            delete params.query.end_date
            const {
                data = {}
            } = (await getWaitDataApi(params)) || {}
            var list = (get(data, 'data.list') || []).map(item => { return { ...item, 'invoice_amount': get(item, 'invoice_remain_amount') } })
            set(waitSearchParams, 'total', get(data, 'data.total_count'))
            this.setState({ waitData: list })
            this.changeLoading(false)
        } catch (err) {
            console.log(err)
            this.changeLoading(false)
        }
    }


    changeThisMatchMoney = (record, value) => {
        var cloneData = _.cloneDeep(this.state.waitData)
        let { selectedRows } = this.state
        if (value == '0') {
            // message.warning('本次匹配金额不能等于0')
            return
        }
        cloneData.forEach(item => {
            if (get(item, 'supplier_account_code') == get(record, 'supplier_account_code')) {
                set(item, 'invoice_amount', value)
            }
        })
        this.setState({
            waitData: cloneData,
            selectedRows: sameChange(selectedRows || [], cloneData, 'supplier_account_code')
        })
    }

    toSigoPage = (record) => {
        console.log(record, 'record')
    }

    monthChange = (key, date, dateString) => {
        var dateM = date
        if (key == 'beign_date') {
            dateM = dateM ? moment(dateM.startOf("month")) : null
        } else {
            dateM = dateM ? moment(dateM.endOf("month")) : null
        }
        let { waitSearchParams } = this.state
        set(waitSearchParams, 'query.' + key, dateM)
        this.setState({ waitSearchParams })
    }

    dateChange = (paramsK, dataArr) => {
        let params = this.state[paramsK]
        set(params, 'query.' + 'beign_date', get(dataArr, '0'))
        set(params, 'query.' + 'end_date', get(dataArr, '0'))
        this.setState({ [paramsK]: params })
    }

    selectChange = (paramsK, valueK, value) => {
        let params = this.state[paramsK]
        set(params, valueK, value)
        this.setState({ [paramsK]: params })
    }

    iptChange = (paramsK, e) => {
        let params = this.state[paramsK]
        set(params, e.target.name, e.target.value.trim())
        this.setState({ [paramsK]: params })
    }


    reset = () => {
        window.location.reload()
    }

    changeTab = (tab) => {
        this.setState({ tab })
        if (tab == 1) {
            this.changeLoading(true)
            _.defer(this.getWaitData, 1000)
        }
    }

    toMatchPage = async () => {
        let { selectedRows } = this.state
        if (!get(selectedRows, 'length')) {
            message.error('请选择匹配单')
            return
        }
        //check 0
        if (get(_.filter(selectedRows, function (o) { return !Math.abs(o.invoice_amount); }), 'length')) {
            message.error('匹配单的本次匹配金额不能为0元，请填写', 3)
            return
        }
        var params = {
            sid: getSid(),
            account_list: selectedRows.map(item => {
                var { supplier_account_code, supplier_account_id, invoice_amount, po_subject_code, po_subject_name } = item || {}
                return {
                    account_no: supplier_account_code,
                    account_id: supplier_account_id,
                    invoice_amount,
                    buyer_no: po_subject_code,
                    buyer_name: po_subject_name,
                }
            })
        }
        try {
            let res = await setTemp(params)
            window.open('http://' + window.location.host + '/main/bill/match/detail?tempid=' + get(res, 'data.data'),'_self')
        } catch (err) {
            console.log(err)
        }
    }

    getWaitMatchHtml = () => {
        let { waitSearchParams, loading, waitData, selectedRows,sigoCompanys } = this.state
        const rowSelection = {
            onChange: (selectedRowKeys, selectedRows) => {
                this.setState({
                    selectedRows
                })
            },
            selectedRowKeys: (selectedRows || []).map(item => item.supplier_account_code),
            getCheckboxProps: (record) => ({

            }),
        };

        var summaryMoney = _.reduce((sameChange(selectedRows || [], waitData, 'supplier_account_code') || []).map(item => item.invoice_amount), function (sum, n) {
            return sum + n;
        }, 0)
        var columns = [
            {
                title: "视客账单号",
                key: "supplier_account_code",
                dataIndex: "supplier_account_code",
                width: 130,
                render: (text, record) => {
                    text = get(record, 'supplier_account_code')
                    return <a href={`/main/supplierRecantion/listDetails?code=${text}&poSubjectName=${get(record, 'po_subject_name')}`} target={'_blank'}>{text}</a>
                }
            },
            {
                title: "结算主体",
                key: "po_subject_name",
                dataIndex: "po_subject_name",
                width: 170,
                render: (text, record) => {
                    text = get(record, 'po_subject_name')
                    return <span>{text || '-'}</span>
                }
            },
            {
                title: "账期",
                key: "supplier_account_begin_date",
                dataIndex: "supplier_account_begin_date",
                width: 170,
                render: (text, record) => {
                    text = get(record, 'supplier_account_begin_date')
                    return <span>
                        {getFormatDateIsNull(get(record, 'supplier_account_begin_date'),)}
                        ～
                        {getFormatDateIsNull(get(record, 'supplier_account_end_date'), 'YYYY-MM-DD')}
                    </span>
                }
            },
            {
                title: "出账时间",
                key: "add_time",
                dataIndex: "add_time",
                width: 150,
                render: (text, record) => {
                    text = get(record, 'add_time')
                    return <span>{get(record, 'add_time') ? getFormatDate(get(record, 'add_time'),'','YYYY-MM-DD') : "-"}</span>
                }
            },
            {
                title: "备注",
                key: "remark",
                dataIndex: "remark",
                width: 150,
                render: (text, record) => {
                    text = get(record, 'remark')
                    return <span>{text || '-'}</span>
                }
            },
            {
                title: "账单总金额（元）",
                key: "statement_amount",
                dataIndex: "statement_amount",
                width: 150,
                render: (text, record) => <div style={{ textAlign: "right" }}>{outputMoney(get(record, 'statement_amount'))}</div>
            },
            {
                title: "剩余可匹配金额（元）",
                key: "invoice_remain_amount",
                dataIndex: "invoice_remain_amount",
                width: 150,
                render: (text, record) => <div style={{ textAlign: "right" }}>{outputMoney(get(record, 'invoice_remain_amount'))}</div>
            },
            {
                title: "本次匹配金额（元）",
                key: "invoice_amount",
                dataIndex: "invoice_amount",
                width: 150,
                render: (text, record) => {
                    text = get(record, 'invoice_amount')
                    return (
                        (this.state && this.state.selectedRows || []).map(item => item.supplier_account_code).includes(get(record, 'supplier_account_code')) ?
                            <InputNumber
                                precision={2}
                                min={get(record, 'invoice_remain_amount') < 0 ? get(record, 'invoice_remain_amount') : 0}
                                style={{ width: "150px" }}
                                max={get(record, 'invoice_remain_amount') < 0 ? 0 : get(record, 'invoice_remain_amount')}
                                value={get(record, 'invoice_amount')}
                                onChange={this.changeThisMatchMoney.bind(this, record)} />
                            : 
                                get(record,'is_occupy')?
                                <div style={{ textAlign: "right" }}>
                                    <Tooltip placement="topLeft" title={<span style={{fontSize:12}}>占用中：{(get(record.match_id_list,'length') > 1 ? get(record,'match_id_list').join(',') : (get(record,'match_id_list[0]') || ''))}</span>}>
                                        {outputMoney(text)}
                                    </Tooltip>
                                </div>
                                :<div style={{textAlign:"right"}}>{outputMoney(text)}</div>
                    )

                }
            },
        ]

        const pipeline = new TablePipeline({
            state: this.state.pipelineState,
            setState: (updater) => {
                // this.setPipelineState 被调用时，第一个参数 updater 是一个函数
                // updater 接受原来的 pipelineState，返回新的 pipelineState
                this.setState((prev) => { updater(prev.pipelineState) })
            },
            ctx: { components: { Checkbox } },
        })

        pipeline.input({
            dataSource: (waitData || []),
            columns:filterSigoCompanyCol(get(sigoCompanys,'length'),columns) ,
        })
        pipeline.primaryKey('supplier_account_code')
        pipeline.use(
            features.multiSelect({
                highlightRowWhenSelected: true,
                isDisabled: (row,rowIndex)=>{return get(row,'is_occupy')},
                value: (selectedRows || []).map(item => get(item, 'supplier_account_code')),
                onChange: (selectKeys, selectItem) => {
                    var data = []
                    selectKeys.forEach(item => {
                        data = data.concat(_.filter(waitData, ['supplier_account_code', item]))
                    })
                    this.setState({ selectedRows: data })
                }
            })
        )
        var next_month = moment().startOf('month').subtract('month', -1)
        return (
            <div>
                <section className='roundBorder mb24'>
                    <span>
                        账期所在月份：
                        <DatePicker
                            onChange={this.monthChange.bind(this, 'beign_date')}
                            value={get(waitSearchParams, 'query.beign_date')}
                            picker="month"
                            disabledDate={(current) => {
                                return current && current > next_month
                            }}
                        />
                        <span className='ml4 mr4'>至</span>
                        <DatePicker
                            onChange={this.monthChange.bind(this, 'end_date')}
                            value={get(waitSearchParams, 'query.end_date')}
                            disabledDate={(current) => {
                                return current && current > next_month
                            }}

                            picker="month"
                        />
                    </span>
                    {
                        get(this.state.sigoCompanys, 'length') > 1 &&
                        <span className='ml20'>
                            结算主体：
                            <Select
                            allowClear
                                value={get(waitSearchParams, 'query.buyer_no') || undefined}
                                style={{ width: 250 }}
                                options={this.state.sigoCompanys}
                                placeholder='请选择'
                                optionFilterProp="label"
                                onChange={this.selectChange.bind(this, 'waitSearchParams', 'query.buyer_no')}
                            >
                            </Select>
                        </span>
                    }

                    <span className='ml20'>
                        视客账单号：
                        <Input
                            style={{ width: 150 }}
                            placeholder="请输入"
                            value={get(waitSearchParams, 'query.supplier_account_code')}
                            name='query.supplier_account_code'
                            onChange={this.iptChange.bind(this, 'waitSearchParams')}
                        />
                    </span>
                    <Button
                        className='ml24'
                        shape="round"
                        type='primary'
                        onClick={this.getWaitData}
                    >查询</Button>
                    <Button className='ml12' onClick={this.reset} shape="round">重置</Button>
                </section>
                <section className='roundBorder BaseTable boldHeader'>
                    <Spin spinning={get(loading, 'wait_table')} >
                        <BaseTable
                            className='antd_table_style mb24 '
                            useOuterBorder
                            style={{ maxHeight: 560, overflow: 'auto', '--cell-border': 'none' }}
                            {...pipeline.getProps()}
                        />
                    </Spin>
                    <section className={'selected'}>
                        已选账单：<span className={get(selectedRows, 'length') && 'redFont'}>{get(selectedRows, 'length') || 0}</span>
                        <span className='ml20'>
                            合计待匹配金额：
                            <span className={get(selectedRows, 'length') && 'redFont'}>
                                {outputMoney(summaryMoney || 0)}
                            </span>
                        </span>
                        <Button
                            className='ml24'
                            type='primary'
                            onClick={this.toMatchPage}
                            disabled={!get(selectedRows, 'length')}
                        >新建发票匹配</Button>
                    </section>
                </section>
            </div>
        )
    }

    render() {
        let { loading,waitSearchParams } = this.state
        return (
            <div className='matchlist'>
                <Spin spinning={get(loading, 'all')} >
                    <Alert
                        message={<div>
                            友情提醒：
                                1、增值税专用发票开具后需上传税局系统，否则发票匹配时将无法查询到已开票数据；若您已上传仍然无法查询到数据，请点此
                                <a onClick={this.getSystemInvoice}>手动获取</a>；
                                2、对账单匹配发票的操作流程，点此
                                <a target={'_blank'} href='https://static.njtuling.com/erp/zizhi/img/20221201100510.png' >查看说明</a>
                                ；详细的操作步骤，请点此
                                <a target={'_blank'} href='https://static.njtuling.com/erp/zizhi/file/20221208155646.pdf' >下载手册</a>
                        </div>}
                        type="warning"
                        showIcon
                    />

                    <Tabs activeKey={this.state.tab} onChange={this.changeTab}>
                        <Tabs.TabPane tab={`待匹配账单（${get(waitSearchParams, 'total')||0}）`} key="1">
                            {this.getWaitMatchHtml()}
                        </Tabs.TabPane>
                        <Tabs.TabPane tab="已匹配记录" key="2">
                        </Tabs.TabPane>
                    </Tabs>
                    {
                        this.state.tab == 2 &&
                        <MatchedList
                            sigoCompanys={this.state.sigoCompanys || []}
                        />
                    }
                </Spin>

            </div>
        );
    }
}

export default Matchlist;


// WEBPACK FOOTER //
// ./src/pages/billVerification/match/list/list.js